import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface LocalInferenceStatus {
    ready: boolean;
    state: string;
    backend: string;
    device: string;
    modelDir: string;
    models: any;
    dependencies: any;
    missing: string[];
    missingDependencies: string[];
    error: string;
    modelVersion: string;
}

interface InferenceStatus {
    connected: boolean;
    label: string;
    model: string;
    device: string;
    source: string;
    local: LocalInferenceStatus;
    externalConfigured: boolean;
}

interface SystemStatus {
    project: string;
    inference: InferenceStatus;
    pipeline: { upload: boolean; maxUploadBytes: number; retention: string; };
    sources: string[];
    toolApi: any;
    agent: any;
}

interface AnalysisResult {
    className: string;
    confidence: number;
    occurrenceSeconds: number | null;
    timestamp: string;
    riskLevel: 'normal' | 'warning' | 'danger' | string;
    summary: string;
    details?: any;
}

interface AnalysisJob {
    id: string;
    state: string;
    progress: number;
    createdAt: string;
    updatedAt: string;
    source: { name: string; size: number; mimeType: string; sha256: string; };
    result: AnalysisResult | null;
    error: string;
}

interface DatasetStatus {
    state: string;
    rawVideos: number;
    labelFiles: number;
    manifestRecords: number;
    invalidRecords: number;
    processedFiles: number;
    totalBytes: number;
    lastPreparedAt: string;
    classCounts: { [key: string]: number };
    splitCounts: { [key: string]: number };
    paths: { raw: string; labels: string; processed: string; };
    registered: boolean;
    registeredAt: string;
    validation: any;
    sequences: any;
    training: any;
    download: any;
    capacityProcessing: any;
    access: any;
    manualImport: any;
    validationErrors: Array<{ label_file: string; message: string }>;
}

interface OperationsSummary {
    total: number;
    completed: number;
    waiting: number;
    failed: number;
    states: { [key: string]: number };
}

interface AIHubPair {
    id: string;
    name: string;
    className: string;
    split: string;
    location: string;
    totalBytes: number;
    fileKeys: number[];
    source: { name: string; sizeBytes: number; sizeDisplay: string; fileKey: number; };
    label: { name: string; sizeBytes: number; sizeDisplay: string; fileKey: number; };
}

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
:host {
  --ink: #17201e;
  --muted: #6d7975;
  --line: #dfe5e1;
  --surface: #ffffff;
  --canvas: #f1f4f2;
  --navy: #111c1a;
  --navy-soft: #1a2926;
  --teal: #137c70;
  --teal-bright: #2ec4a6;
  --amber: #d8911d;
  --danger: #d84b42;
  display: block;
  min-height: 100vh;
  color: var(--ink);
  background: var(--canvas);
  font-family: "SUIT", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

* {
  box-sizing: border-box;
}

button, input {
  font: inherit;
}

.ops-shell {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 236px minmax(0, 1fr);
}

.rail {
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 30px 20px 22px;
  color: #eef6f3;
  background: linear-gradient(145deg, rgba(46, 196, 166, 0.07), transparent 38%), var(--navy);
  border-right: 1px solid rgba(255, 255, 255, 0.06);
}

.rail-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 8px;
  color: inherit;
  text-decoration: none;
}

.brand-symbol {
  width: 39px;
  height: 39px;
  display: grid;
  place-items: center;
  color: var(--teal-bright);
  background: rgba(46, 196, 166, 0.08);
  border: 1px solid rgba(46, 196, 166, 0.22);
  border-radius: 11px;
}

.brand-symbol svg {
  width: 27px;
  height: 27px;
}

.brand-copy strong, .brand-copy small {
  display: block;
}

.brand-copy strong {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.brand-copy small {
  margin-top: 3px;
  color: #718984;
  font: 700 7px/1 monospace;
  letter-spacing: 0.18em;
}

.rail-nav {
  display: grid;
  gap: 7px;
  margin-top: 62px;
}

.rail-nav button {
  width: 100%;
  min-height: 48px;
  display: grid;
  grid-template-columns: 30px 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  color: #81938f;
  border: 0;
  border-radius: 9px;
  background: transparent;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
  transition: 0.18s ease;
}

.rail-nav button:hover {
  color: #d9e7e3;
  background: rgba(255, 255, 255, 0.04);
}

.rail-nav button.active {
  color: #fff;
  background: rgba(46, 196, 166, 0.11);
  box-shadow: inset 2px 0 var(--teal-bright);
}

.rail-nav button b {
  min-width: 22px;
  padding: 4px 5px;
  color: #8aa19c;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  font: 700 8px/1 monospace;
  text-align: center;
}

.nav-icon {
  color: #50645f;
  font: 700 8px/1 monospace;
  letter-spacing: 0.06em;
}

.rail-nav button.active .nav-icon {
  color: var(--teal-bright);
}

.rail-health {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 12px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.025);
}

.health-light, .engine-light, .metric-dot {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--amber);
  box-shadow: 0 0 0 5px rgba(216, 145, 29, 0.1);
}

.health-light.online, .engine-light.online, .metric-dot.online {
  background: var(--teal-bright);
  box-shadow: 0 0 0 5px rgba(46, 196, 166, 0.1);
}

.rail-health strong, .rail-health small {
  display: block;
}

.rail-health strong {
  font-size: 10px;
}

.rail-health small {
  margin-top: 4px;
  color: #637873;
  font: 700 7px/1 monospace;
}

.ops-main {
  min-width: 0;
  padding: 0 34px;
}

.ops-header {
  min-height: 102px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  border-bottom: 1px solid var(--line);
}

.ops-header p {
  margin: 0 0 7px;
  color: #84908d;
  font: 700 8px/1 monospace;
  letter-spacing: 0.15em;
}

.ops-header h1 {
  margin: 0;
  font-size: 23px;
  font-weight: 800;
  letter-spacing: -0.035em;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.environment {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 10px;
  color: #67736f;
  background: #e6ebe8;
  border-radius: 6px;
  font: 800 8px/1 monospace;
}

.environment i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--teal);
}

.refresh {
  height: 34px;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  color: #4f5e5a;
  border: 1px solid #d6ddda;
  border-radius: 7px;
  background: white;
  font-size: 10px;
  font-weight: 750;
  cursor: pointer;
}

.refresh:hover:not(:disabled) {
  border-color: #aebbb7;
}

.refresh:disabled {
  opacity: 0.55;
  cursor: wait;
}

.refresh svg {
  width: 14px;
  height: 14px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  padding: 20px 0;
}

.summary-card {
  min-height: 112px;
  position: relative;
  padding: 17px 18px;
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: 11px;
  background: var(--surface);
  box-shadow: 0 2px 5px rgba(20, 37, 32, 0.025);
}

.summary-card::after {
  content: "";
  position: absolute;
  width: 72px;
  height: 72px;
  right: -28px;
  bottom: -38px;
  border: 1px solid #e8ecea;
  border-radius: 50%;
}

.summary-card > div {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.summary-card span {
  color: #73807c;
  font-size: 9px;
  font-weight: 700;
}

.summary-card strong {
  font: 800 22px/1 monospace;
  letter-spacing: -0.05em;
}

.summary-card > b {
  display: block;
  margin-top: 13px;
  color: var(--teal);
  font-size: 9px;
}

.summary-card > b.warning {
  color: #b37415;
}

.summary-card > small {
  display: block;
  margin-top: 5px;
  color: #9aa39f;
  font-size: 8px;
}

.summary-card.primary {
  color: #f0faf7;
  background: var(--navy-soft);
  border-color: var(--navy-soft);
}

.summary-card.primary span, .summary-card.primary > small {
  color: #7f9892;
}

.summary-card.primary::after {
  border-color: rgba(255, 255, 255, 0.07);
}

.summary-card.dataset {
  background: #edf6f3;
  border-color: #d9ebe5;
}

.summary-card.agent-summary {
  background: #f4f0fa;
  border-color: #e6dcf2;
}

.agent-layout {
  display: grid;
  grid-template-columns: minmax(340px, 0.8fr) minmax(0, 1.2fr);
  gap: 14px;
}

.agent-input {
  display: grid;
  gap: 14px;
  padding: 20px;
}

.agent-input label > span, .agent-video > span {
  display: block;
  margin-bottom: 7px;
  color: #77837f;
  font-size: 8px;
  font-weight: 800;
}

.agent-input textarea {
  width: 100%;
  resize: vertical;
  padding: 12px;
  color: var(--ink);
  border: 1px solid #d7dfdb;
  border-radius: 7px;
  background: #fbfcfb;
  font-size: 11px;
  line-height: 1.55;
}

.agent-video {
  padding: 12px;
  border: 1px solid var(--line);
  border-radius: 7px;
  background: #f8faf9;
}

.agent-video strong {
  display: block;
  overflow: hidden;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-video label {
  display: inline-flex;
  margin-top: 10px;
  padding: 7px 9px;
  color: var(--teal);
  border: 1px solid #cfe2dc;
  border-radius: 5px;
  background: white;
  font-size: 8px;
  font-weight: 800;
  cursor: pointer;
}

.agent-video input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.agent-error {
  margin: 0;
  padding: 10px;
  color: #986713;
  border-radius: 6px;
  background: #fff4df;
  font-size: 9px;
  line-height: 1.5;
}

.agent-flow {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr auto 1fr;
  align-items: stretch;
  gap: 8px;
  padding: 20px;
}

.agent-flow > div {
  min-width: 0;
  min-height: 105px;
  padding: 14px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fafcfb;
}

.agent-flow > div.done {
  border-color: #a9d9cc;
  background: #edf8f4;
}

.agent-flow > div span, .agent-flow > div strong, .agent-flow > div small {
  display: block;
}

.agent-flow > div span {
  color: var(--teal);
  font: 800 8px/1 monospace;
}

.agent-flow > div strong {
  margin-top: 16px;
  font-size: 10px;
}

.agent-flow > div small {
  margin-top: 7px;
  color: #84908d;
  font-size: 8px;
  line-height: 1.45;
}

.agent-flow > i {
  align-self: center;
  color: #a8b3af;
  font-style: normal;
}

.agent-result {
  margin: 0 20px 16px;
  padding: 15px;
  color: #dfece8;
  border-radius: 8px;
  background: var(--navy);
}

.agent-result span {
  color: var(--teal-bright);
  font: 800 7px/1 monospace;
}

.agent-result p {
  margin: 9px 0 0;
  font-size: 10px;
  line-height: 1.6;
}

.tool-call-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin: 0 20px 16px;
}

.tool-call-list > div {
  padding: 10px;
  border: 1px solid var(--line);
  border-radius: 6px;
}

.tool-call-list span, .tool-call-list strong {
  display: block;
}

.tool-call-list span {
  color: #8a9692;
  font: 750 7px/1 monospace;
}

.tool-call-list strong {
  margin-top: 6px;
  font-size: 9px;
}

.agent-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-top: 14px;
}

.cv-values {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 16px 20px 8px;
}

.cv-values div {
  padding: 11px;
  border: 1px solid var(--line);
  border-radius: 7px;
  background: #fafcfb;
}

.cv-values span, .cv-values strong {
  display: block;
}

.cv-values span {
  color: #7f8b87;
  font-size: 8px;
}

.cv-values strong {
  margin-top: 6px;
  font: 800 15px/1 monospace;
}

.cv-metrics-card > p {
  margin: 8px 20px 18px;
  color: #7d8985;
  font-size: 9px;
  line-height: 1.55;
}

.card {
  min-width: 0;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--surface);
  box-shadow: 0 3px 12px rgba(20, 37, 32, 0.025);
}

.card-head {
  min-height: 67px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 20px;
  border-bottom: 1px solid var(--line);
}

.card-head.compact {
  min-height: 60px;
}

.card-head > div h2 {
  margin: 3px 0 0;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.section-index {
  color: #8c9894;
  font: 800 7px/1 monospace;
  letter-spacing: 0.14em;
}

.monitor-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(330px, 0.75fr);
  gap: 14px;
}

.monitor-side {
  display: grid;
  grid-template-rows: minmax(328px, auto) auto;
  gap: 14px;
}

.source-switch {
  display: flex;
  padding: 3px;
  background: #eef2f0;
  border-radius: 7px;
}

.source-switch button {
  min-width: 51px;
  height: 26px;
  color: #7a8582;
  border: 0;
  border-radius: 5px;
  background: transparent;
  font-size: 8px;
  font-weight: 750;
  cursor: pointer;
}

.source-switch button.active {
  color: var(--ink);
  background: white;
  box-shadow: 0 1px 3px rgba(20, 37, 32, 0.12);
}

.media-viewport {
  min-height: 320px;
  position: relative;
  margin: 18px 20px 0;
  overflow: hidden;
  display: grid;
  place-items: center;
  color: #d6e1de;
  background: #162320;
  border: 1px solid #253834;
  border-radius: 9px;
}

.media-viewport video {
  width: 100%;
  height: 320px;
  display: block;
  object-fit: contain;
  background: #07100e;
}

.media-viewport input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.drop-zone {
  width: 100%;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8ca09b;
  cursor: pointer;
  background-image: linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
  background-size: 28px 28px;
}

.drop-zone strong {
  margin-top: 15px;
  color: #edf5f2;
  font-size: 12px;
}

.drop-zone > span:not(.upload-glyph) {
  margin-top: 7px;
  color: #657a75;
  font: 700 7px/1 monospace;
}

.drop-zone > b {
  margin-top: 19px;
  padding: 9px 14px;
  color: #d9f8f0;
  background: rgba(46, 196, 166, 0.13);
  border: 1px solid rgba(46, 196, 166, 0.26);
  border-radius: 6px;
  font-size: 9px;
}

.upload-glyph {
  width: 43px;
  height: 43px;
  display: grid;
  place-items: center;
  color: var(--teal-bright);
  border: 1px solid rgba(46, 196, 166, 0.25);
  border-radius: 50%;
  background: rgba(46, 196, 166, 0.07);
}

.upload-glyph svg {
  width: 20px;
  height: 20px;
}

.viewport-grid {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(90deg, transparent 49.8%, rgba(46, 196, 166, 0.12) 50%, transparent 50.2%), linear-gradient(transparent 49.8%, rgba(46, 196, 166, 0.12) 50%, transparent 50.2%);
}

.live-tag {
  position: absolute;
  top: 12px;
  left: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  color: #d8e6e2;
  background: rgba(7, 16, 14, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  font: 700 7px/1 monospace;
}

.live-tag i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--danger);
}

.media-viewport.unavailable {
  min-height: 320px;
  align-content: center;
  gap: 8px;
  padding: 35px;
  text-align: center;
}

.media-viewport.unavailable > span {
  color: var(--teal-bright);
  font: 800 9px/1 monospace;
  letter-spacing: 0.16em;
}

.media-viewport.unavailable strong {
  font-size: 13px;
}

.media-viewport.unavailable p {
  max-width: 400px;
  margin: 0;
  color: #71857f;
  font-size: 9px;
  line-height: 1.55;
}

.file-control {
  min-height: 61px;
  margin: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px solid var(--line);
}

.file-meta {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-type {
  flex: 0 0 auto;
  padding: 5px 6px;
  color: #899590;
  background: #edf1ef;
  border-radius: 4px;
  font: 800 7px/1 monospace;
}

.file-control.ready .file-type {
  color: var(--teal);
  background: #e2f2ed;
}

.file-meta > div {
  min-width: 0;
}

.file-meta strong, .file-meta small {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-meta strong {
  max-width: 390px;
  font-size: 10px;
}

.file-meta small {
  max-width: 420px;
  margin-top: 4px;
  color: #84908d;
  font-size: 8px;
}

.text-button, .link-button {
  color: var(--teal);
  border: 0;
  background: none;
  font-size: 9px;
  font-weight: 750;
  cursor: pointer;
}

.analysis-control {
  padding: 15px 20px 20px;
}

.progress-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #6d7a76;
  font-size: 9px;
}

.progress-row strong {
  color: var(--ink);
  font: 800 9px/1 monospace;
}

.progress-track {
  height: 3px;
  margin: 9px 0 14px;
  overflow: hidden;
  background: #e8ecea;
  border-radius: 2px;
}

.progress-track i {
  height: 100%;
  display: block;
  background: var(--teal);
  transition: width 0.2s ease;
}

.analyze {
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: white;
  border: 0;
  border-radius: 7px;
  background: var(--teal);
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
}

.analyze:hover:not(:disabled) {
  background: #0e6c62;
}

.analyze:disabled {
  color: #99a6a2;
  background: #e3e8e5;
  cursor: not-allowed;
}

.analyze svg {
  width: 15px;
  height: 15px;
}

.status-chip {
  padding: 5px 7px;
  color: #8b9692;
  background: #edf1ef;
  border-radius: 4px;
  font: 800 7px/1 monospace;
}

.status-chip.has-result {
  color: #08715f;
  background: #dff3ec;
}

.result-empty {
  min-height: 266px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
}

.radar {
  width: 82px;
  height: 82px;
  position: relative;
}

.radar span {
  position: absolute;
  inset: 0;
  border: 1px solid #dbe4e0;
  border-radius: 50%;
}

.radar span:nth-child(2) {
  inset: 14px;
}

.radar span:nth-child(3) {
  inset: 28px;
  background: #f0f6f3;
}

.radar i {
  position: absolute;
  width: 7px;
  height: 7px;
  top: 37px;
  left: 37px;
  border-radius: 50%;
  background: var(--teal);
  box-shadow: 0 0 0 6px rgba(19, 124, 112, 0.09);
}

.result-empty strong {
  margin-top: 17px;
  font-size: 12px;
}

.result-empty p {
  max-width: 260px;
  margin: 7px 0 0;
  color: #84908d;
  font-size: 9px;
  line-height: 1.5;
}

.result-data {
  min-height: 266px;
  padding: 24px;
}

.risk-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.risk-heading > span {
  padding: 6px 8px;
  color: #08715f;
  background: #dff3ec;
  border-radius: 5px;
  font-size: 9px;
  font-weight: 800;
}

.risk-heading > strong {
  color: var(--teal);
  font: 900 36px/1 monospace;
  letter-spacing: -0.06em;
}

.risk-heading > strong small {
  font-size: 13px;
}

.result-data[data-risk=danger] .risk-heading > span {
  color: #a3322c;
  background: #fde7e5;
}

.result-data[data-risk=danger] .risk-heading > strong {
  color: var(--danger);
}

.result-data[data-risk=warning] .risk-heading > span {
  color: #94600e;
  background: #fff0d4;
}

.result-data[data-risk=warning] .risk-heading > strong {
  color: var(--amber);
}

.result-data h3 {
  margin: 25px 0 5px;
  font-size: 19px;
  letter-spacing: -0.03em;
}

.result-data > p {
  min-height: 30px;
  margin: 0;
  color: #77837f;
  font-size: 9px;
  line-height: 1.5;
}

.result-data dl {
  margin: 18px 0 0;
}

.result-data dl div, .engine-list div {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  padding: 9px 0;
  border-top: 1px solid var(--line);
  font-size: 9px;
}

.result-data dt, .engine-list dt {
  color: #84908d;
}

.result-data dd, .engine-list dd {
  margin: 0;
  max-width: 62%;
  font-weight: 750;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.engine-card .card-head {
  border-bottom: 0;
}

.engine-list {
  margin: 0;
  padding: 0 20px 16px;
}

.engine-list div {
  padding: 8px 0;
}

.engine-light {
  margin-right: 3px;
}

.recent-strip {
  margin-top: 14px;
}

.compact-list {
  padding: 0 20px 14px;
}

.job-row {
  width: 100%;
  min-height: 49px;
  display: grid;
  grid-template-columns: 73px minmax(160px, 1.2fr) 70px 95px 110px 15px;
  align-items: center;
  gap: 12px;
  padding: 0 2px;
  color: #6d7975;
  border: 0;
  border-bottom: 1px solid var(--line);
  background: transparent;
  font-size: 9px;
  text-align: left;
  cursor: pointer;
}

.job-row:hover {
  background: #fafcfb;
}

.job-row > strong {
  color: var(--ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.job-row time {
  font: 700 8px/1 monospace;
}

.job-row > i {
  color: #a3aca8;
  font-style: normal;
}

.job-status {
  width: fit-content;
  padding: 5px 7px;
  color: #6e7c78;
  border: 0;
  border-radius: 4px;
  background: #edf1ef;
  font-size: 8px;
  font-weight: 800;
  white-space: nowrap;
}

.job-status[data-state=completed] {
  color: #08715f;
  background: #dff3ec;
}

.job-status[data-state=waiting_for_model] {
  color: #94600e;
  background: #fff0d4;
}

.job-status[data-state=failed] {
  color: #a3322c;
  background: #fde7e5;
}

.empty-table {
  min-height: 86px;
  display: grid;
  place-items: center;
  color: #8b9692;
  font-size: 9px;
}

.empty-table.large {
  min-height: 300px;
}

.page-card {
  min-height: 540px;
}

.card-head.page-title {
  min-height: 86px;
}

.page-title p {
  margin: 6px 0 0;
  color: #84908d;
  font-size: 9px;
}

.record-count, .dataset-state {
  padding: 7px 9px;
  color: #697570;
  background: #edf1ef;
  border-radius: 5px;
  font: 800 8px/1 monospace;
}

.history-table {
  padding: 0 20px 24px;
}

.table-head, .table-row {
  display: grid;
  grid-template-columns: 90px minmax(220px, 1.5fr) minmax(100px, 0.8fr) 80px 120px 45px;
  align-items: center;
  gap: 12px;
}

.table-head {
  height: 43px;
  color: #929c98;
  border-bottom: 1px solid var(--line);
  font-size: 8px;
  font-weight: 750;
}

.table-row {
  min-height: 64px;
  color: #5f6c68;
  border-bottom: 1px solid var(--line);
  font-size: 9px;
}

.file-cell {
  min-width: 0;
}

.file-cell strong, .file-cell small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-cell strong {
  color: var(--ink);
  font-size: 10px;
}

.file-cell small {
  margin-top: 5px;
  color: #929c98;
  font: 700 7px/1 monospace;
}

.table-row time {
  color: #7d8985;
  font: 700 8px/1 monospace;
}

.delete-button {
  color: #9b5b56;
  border: 0;
  background: transparent;
  font-size: 8px;
  font-weight: 750;
  cursor: pointer;
}

.download-guide {
  min-height: 112px;
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
  padding: 18px 22px;
  color: #e8f4f0;
  border-radius: 12px;
  background: linear-gradient(110deg, #14231f, #1d3731);
}

.guide-mark {
  width: 45px;
  height: 45px;
  display: grid;
  place-items: center;
  color: var(--teal-bright);
  border: 1px solid rgba(46, 196, 166, 0.3);
  border-radius: 10px;
  background: rgba(46, 196, 166, 0.08);
  font: 900 11px/1 monospace;
}

.download-guide span {
  color: #6f938a;
  font: 800 7px/1 monospace;
  letter-spacing: 0.14em;
}

.download-guide h2 {
  margin: 6px 0 4px;
  font-size: 14px;
}

.download-guide p {
  margin: 0;
  color: #8fa8a1;
  font-size: 9px;
  line-height: 1.5;
}

.download-guide a {
  padding: 10px 13px;
  color: #dff8f1;
  border: 1px solid rgba(46, 196, 166, 0.25);
  border-radius: 7px;
  background: rgba(46, 196, 166, 0.08);
  font-size: 9px;
  font-weight: 800;
  text-decoration: none;
  white-space: nowrap;
}

.download-guide a b {
  margin-left: 7px;
  color: var(--teal-bright);
}

.download-console {
  margin-bottom: 14px;
}

.download-body {
  display: grid;
  grid-template-columns: 1.35fr 0.8fr;
  gap: 22px;
  padding: 20px 24px 15px;
}

.approval-steps {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin: 0;
  padding: 0;
}

.approval-steps li {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 11px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fafcfb;
}

.approval-steps li > span {
  width: 25px;
  height: 25px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  color: var(--teal);
  border-radius: 50%;
  background: #e4f2ee;
  font: 800 8px/1 monospace;
}

.approval-steps strong, .approval-steps small {
  display: block;
}

.approval-steps strong {
  font-size: 9px;
}

.approval-steps small {
  margin-top: 4px;
  color: #8a9591;
  font-size: 7px;
  line-height: 1.35;
}

.download-action {
  min-width: 0;
  display: grid;
  grid-template-columns: 105px minmax(170px, 1fr);
  gap: 8px;
}

.download-action label span {
  display: block;
  margin-bottom: 6px;
  color: #7d8985;
  font-size: 8px;
  font-weight: 750;
}

.download-action input {
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border: 1px solid #d9e0dc;
  border-radius: 6px;
  background: #fbfcfb;
  font-size: 9px;
}

.download-action .one-time-key {
  grid-column: 2;
}

.download-action .one-time-key input {
  font-family: monospace;
  letter-spacing: 0.08em;
}

.download-checks {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 7px;
  padding-bottom: 3px;
}

.download-checks span {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #8b9692;
  font-size: 7px;
}

.download-checks i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #c7cfcb;
}

.download-checks span.pass {
  color: #327a6d;
}

.download-checks span.pass i {
  background: var(--teal-bright);
}

.download-action button {
  grid-column: 1/-1;
  height: 34px;
  color: white;
  border: 0;
  border-radius: 6px;
  background: var(--teal);
  font-size: 9px;
  font-weight: 800;
  cursor: pointer;
}

.download-action button.capacity-start {
  background: #203d36;
}

.download-action button:disabled {
  color: #99a5a1;
  background: #e3e8e5;
  cursor: not-allowed;
}

.capacity-progress {
  margin: 0 24px 14px;
  padding: 12px 14px;
  border: 1px solid #dfe6e2;
  border-radius: 8px;
  background: #f3f6f4;
}

.capacity-progress > div:first-child {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #66736f;
  font-size: 8px;
  font-weight: 750;
}

.capacity-progress > div:first-child strong {
  font: 800 8px/1 monospace;
}

.capacity-progress p {
  margin: 8px 0 0;
  color: #71807b;
  font-size: 8px;
}

.capacity-progress small {
  display: block;
  margin-top: 5px;
  color: #8b9692;
  font: 700 7px/1.4 monospace;
}

.capacity-progress[data-state=running] {
  border-color: #b9ded2;
  background: #eaf7f2;
}

.capacity-progress[data-state=failed] {
  border-color: #efcbc8;
  background: #fff0ef;
}

.access-diagnostic {
  display: grid;
  grid-template-columns: repeat(5, minmax(90px, 1fr)) auto;
  align-items: center;
  gap: 9px;
  margin: 0 24px 14px;
  padding: 12px 14px;
  border: 1px solid #dfe6e2;
  border-radius: 8px;
  background: #f7f9f8;
}

.access-diagnostic > div span, .access-diagnostic > div strong {
  display: block;
}

.access-diagnostic > div span {
  color: #8a9692;
  font: 750 6px/1 monospace;
}

.access-diagnostic > div strong {
  margin-top: 5px;
  overflow: hidden;
  color: #53615c;
  font: 800 7px/1 monospace;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.access-diagnostic button {
  height: 34px;
  padding: 0 12px;
  color: white;
  border: 0;
  border-radius: 6px;
  background: #203d36;
  font-size: 8px;
  font-weight: 800;
  cursor: pointer;
}

.access-diagnostic button:disabled {
  color: #99a5a1;
  background: #e1e6e3;
  cursor: not-allowed;
}

.access-diagnostic p {
  grid-column: 1/-1;
  margin: 2px 0 0;
  color: #7f8b87;
  font-size: 8px;
}

.access-diagnostic[data-state=approved] {
  border-color: #b9ded2;
  background: #eaf7f2;
}

.access-diagnostic[data-state=blocked], .access-diagnostic[data-state=failed] {
  border-color: #efcbc8;
  background: #fff0ef;
}

.catalog-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 24px 10px;
  padding-top: 14px;
  border-top: 1px solid var(--line);
}

.catalog-toolbar > div {
  min-width: 0;
  margin-right: auto;
}

.catalog-toolbar strong, .catalog-toolbar small {
  display: block;
}

.catalog-toolbar strong {
  color: #44534e;
  font: 800 8px/1.3 monospace;
}

.catalog-toolbar small {
  margin-top: 4px;
  color: #8a9692;
  font-size: 7px;
}

.catalog-toolbar label {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #7c8984;
  font-size: 8px;
  font-weight: 750;
}

.catalog-toolbar select, .catalog-toolbar button {
  height: 30px;
  padding: 0 9px;
  border: 1px solid #d8e0dc;
  border-radius: 6px;
  background: white;
  color: #51605b;
  font-size: 8px;
  font-weight: 750;
}

.catalog-toolbar button {
  cursor: pointer;
}

.catalog-toolbar button.ghost {
  color: #87928e;
  background: #f7f9f8;
}

.catalog-toolbar button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.catalog-table {
  max-height: 300px;
  margin: 0 24px 12px;
  overflow: auto;
  border: 1px solid var(--line);
  border-radius: 8px;
}

.catalog-head, .catalog-row {
  display: grid;
  grid-template-columns: 42px 110px minmax(180px, 1fr) minmax(180px, 1fr) 90px;
  align-items: center;
  gap: 8px;
}

.catalog-head {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 9px 10px;
  color: #85908c;
  background: #f4f7f5;
  font: 750 7px/1 monospace;
}

.catalog-row {
  min-height: 48px;
  padding: 7px 10px;
  border-top: 1px solid #eef1ef;
  cursor: pointer;
}

.catalog-row:hover {
  background: #fbfdfc;
}

.catalog-row span {
  min-width: 0;
}

.catalog-row strong, .catalog-row small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.catalog-row strong {
  color: #4a5753;
  font-size: 8px;
}

.catalog-row small {
  margin-top: 4px;
  color: #909a96;
  font: 650 7px/1 monospace;
}

.catalog-row b {
  display: inline-block;
  padding: 3px 6px;
  color: #66736f;
  border-radius: 9px;
  background: #edf1ef;
  font-size: 7px;
}

.catalog-row b[data-class=fall] {
  color: #9d3932;
  background: #fdeae8;
}

.catalog-row b[data-class=warning] {
  color: #8d6215;
  background: #fff2d9;
}

.catalog-row b[data-class=normal] {
  color: #257361;
  background: #e4f4ee;
}

.catalog-row input {
  accent-color: var(--teal);
}

.catalog-empty {
  margin: 0 24px 12px;
  padding: 20px;
  color: #8c9692;
  border: 1px dashed #d8dfdc;
  border-radius: 8px;
  text-align: center;
  font-size: 8px;
}

.selection-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(100px, 1fr)) auto;
  align-items: center;
  gap: 10px;
  margin: 0 24px 12px;
  padding: 11px 13px;
  border-radius: 8px;
  background: #eef7f3;
}

.selection-summary.blocked {
  background: #fff0ef;
}

.selection-summary span, .selection-summary strong {
  display: block;
}

.selection-summary span {
  color: #84908b;
  font-size: 7px;
}

.selection-summary strong {
  margin-top: 4px;
  color: #3f554e;
  font: 800 8px/1 monospace;
}

.selection-summary button {
  height: 34px;
  padding: 0 14px;
  color: white;
  border: 0;
  border-radius: 6px;
  background: var(--teal);
  font-size: 8px;
  font-weight: 800;
  cursor: pointer;
}

.selection-summary button:disabled {
  color: #99a5a1;
  background: #dfe5e2;
  cursor: not-allowed;
}

.download-progress {
  margin: 0 24px 20px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #f3f6f4;
}

.download-progress > div:first-child {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #66736f;
  font-size: 8px;
  font-weight: 750;
}

.download-progress > div:first-child strong {
  font: 800 8px/1 monospace;
}

.download-progress p {
  margin: 8px 0 0;
  color: #71807b;
  font-size: 8px;
}

.download-progress small {
  display: block;
  margin-top: 5px;
  color: #8b9692;
  font: 700 7px/1.4 monospace;
}

.download-progress[data-state=failed] {
  color: #9d3932;
  background: #fff0ef;
}

.download-progress[data-state=completed] {
  background: #eaf7f2;
}

.manual-import-card {
  margin-bottom: 14px;
}

.manual-upload-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1.1fr;
  gap: 12px;
  padding: 20px 24px 12px;
}

.manual-upload-grid article {
  min-width: 0;
  padding: 14px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fafcfb;
}

.manual-upload-grid article > span {
  display: block;
  margin-bottom: 10px;
  color: var(--teal);
  font: 800 7px/1 monospace;
}

.manual-upload-grid label {
  min-height: 48px;
  display: grid;
  place-items: center;
  padding: 8px;
  border: 1px dashed #cad6d1;
  border-radius: 6px;
  background: white;
  cursor: pointer;
}

.manual-upload-grid label input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.manual-upload-grid label b {
  color: #65736e;
  font-size: 8px;
}

.manual-upload-grid article > small {
  display: block;
  margin: 8px 0;
  color: #8a9692;
  font: 650 7px/1.3 monospace;
}

.manual-upload-grid button {
  width: 100%;
  height: 33px;
  color: white;
  border: 0;
  border-radius: 6px;
  background: var(--teal);
  font-size: 8px;
  font-weight: 800;
  cursor: pointer;
}

.manual-upload-grid button:disabled {
  color: #9aa5a1;
  background: #e2e7e4;
  cursor: not-allowed;
}

.manual-run dl {
  margin: 0 0 9px;
}

.manual-run dl div {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 0;
  border-bottom: 1px solid #e8ece9;
  font-size: 8px;
}

.manual-run dt {
  color: #87928e;
}

.manual-run dd {
  margin: 0;
  color: #4f5e59;
  font: 750 7px/1 monospace;
}

.manual-progress {
  margin: 0 24px 20px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #f3f6f4;
}

.manual-progress > div:first-child {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #66736f;
  font-size: 8px;
  font-weight: 750;
}

.manual-progress p {
  margin: 8px 0 0;
  color: #71807b;
  font-size: 8px;
}

.manual-progress small {
  display: block;
  margin-top: 5px;
  color: #8b9692;
  font: 700 7px/1.4 monospace;
}

.manual-progress[data-state=failed] {
  background: #fff0ef;
}

.manual-progress[data-state=completed] {
  background: #eaf7f2;
}

.dataset-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(300px, 0.65fr);
  gap: 14px;
}

.dataset-main-column {
  min-width: 0;
  display: grid;
  gap: 14px;
}

.dataset-overview {
  min-height: 540px;
}

.registration-card {
  min-height: 0;
}

.dataset-state[data-state=ready] {
  color: #08715f;
  background: #dff3ec;
}

.dataset-state[data-state=needs_processing] {
  color: #94600e;
  background: #fff0d4;
}

.registration-form {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  align-items: end;
  gap: 10px;
  padding: 20px 28px 14px;
}

.registration-form label, .training-config label {
  min-width: 0;
}

.registration-form label span, .training-config label span {
  display: block;
  margin-bottom: 7px;
  color: #7d8985;
  font-size: 8px;
  font-weight: 750;
}

.registration-form input, .training-config input {
  width: 100%;
  height: 36px;
  padding: 0 11px;
  color: var(--ink);
  border: 1px solid #d9e0dc;
  border-radius: 6px;
  outline: none;
  background: #fbfcfb;
  font-size: 9px;
}

.registration-form input:focus, .training-config input:focus {
  border-color: var(--teal);
  box-shadow: 0 0 0 3px rgba(19, 124, 112, 0.08);
}

.registration-form button, .pipeline-stage-grid button {
  height: 36px;
  padding: 0 14px;
  color: white;
  border: 0;
  border-radius: 6px;
  background: var(--teal);
  font-size: 9px;
  font-weight: 800;
  cursor: pointer;
  white-space: nowrap;
}

.registration-form button:disabled, .pipeline-stage-grid button:disabled {
  color: #99a5a1;
  background: #e3e8e5;
  cursor: not-allowed;
}

.task-message {
  min-height: 44px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 28px;
  padding: 9px 12px;
  color: #687570;
  border-radius: 7px;
  background: #f1f4f2;
  font-size: 8px;
}

.task-message i {
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #a9b3af;
}

.task-message[data-state=running] i {
  background: var(--amber);
  box-shadow: 0 0 0 4px rgba(216, 145, 29, 0.1);
}

.task-message[data-state=completed] i {
  background: var(--teal-bright);
  box-shadow: 0 0 0 4px rgba(46, 196, 166, 0.1);
}

.task-message[data-state=failed] i {
  background: var(--danger);
}

.task-message strong {
  margin-right: 8px;
  color: var(--ink);
}

.dataset-steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  padding: 42px 28px;
}

.dataset-steps > div {
  position: relative;
  display: flex;
  align-items: center;
  gap: 11px;
}

.dataset-steps > div > span {
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  color: #8d9894;
  background: #edf1ef;
  border-radius: 50%;
  font: 800 8px/1 monospace;
}

.dataset-steps > div.done > span {
  color: #eafff9;
  background: var(--teal);
}

.dataset-steps strong, .dataset-steps small {
  display: block;
}

.dataset-steps strong {
  font-size: 10px;
}

.dataset-steps small {
  margin-top: 4px;
  color: #8c9693;
  font: 700 7px/1.3 monospace;
}

.dataset-steps i {
  height: 1px;
  position: absolute;
  left: calc(100% - 18px);
  right: 18px;
  top: 17px;
  background: #dfe5e1;
}

.dataset-steps > div:last-child i {
  display: none;
}

.dataset-command {
  margin: 0 28px;
  padding: 16px;
  color: #b9ccc6;
  background: var(--navy);
  border-radius: 8px;
}

.dataset-command span {
  display: block;
  margin-bottom: 9px;
  color: var(--teal-bright);
  font: 800 7px/1 monospace;
  letter-spacing: 0.15em;
}

.dataset-command code {
  display: block;
  overflow-wrap: anywhere;
  color: #c9d7d3;
  font: 500 9px/1.6 monospace;
}

.path-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 9px;
  margin: 20px 28px 28px;
}

.path-grid div {
  min-width: 0;
  padding: 13px;
  background: #f4f6f5;
  border-radius: 7px;
}

.path-grid span {
  display: block;
  margin-bottom: 7px;
  color: #8a9692;
  font: 800 7px/1 monospace;
}

.path-grid code {
  display: block;
  overflow: hidden;
  color: #4e5e59;
  font: 600 8px/1.4 monospace;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.validation-errors {
  margin: 0 28px 24px;
  padding: 12px;
  border-radius: 7px;
  background: #fff4f2;
}

.validation-errors > strong {
  display: block;
  margin-bottom: 8px;
  color: #9d3932;
  font-size: 8px;
}

.validation-errors > div {
  display: grid;
  grid-template-columns: minmax(120px, 0.8fr) 1.5fr;
  gap: 8px;
  padding: 5px 0;
  border-top: 1px solid #f2dcd9;
  color: #8a5a56;
  font-size: 7px;
}

.validation-errors code {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-side {
  display: grid;
  gap: 14px;
  align-content: start;
}

.distribution-card, .quality-card {
  min-height: 240px;
}

.distribution-list {
  padding: 9px 20px 20px;
}

.distribution-list > div {
  min-height: 41px;
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  color: #6e7a76;
  border-bottom: 1px solid var(--line);
  font-size: 9px;
  overflow: hidden;
}

.distribution-list strong {
  color: var(--ink);
  font: 800 9px/1 monospace;
}

.distribution-list i {
  height: 2px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: var(--teal);
}

.mini-empty {
  min-height: 160px;
  display: grid;
  place-items: center;
  padding: 20px;
  color: #8d9894;
  font-size: 9px;
  text-align: center;
}

.quality-card ul {
  list-style: none;
  margin: 0;
  padding: 8px 20px 20px;
}

.quality-card li {
  min-height: 38px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #687570;
  border-bottom: 1px solid var(--line);
  font-size: 9px;
}

.quality-card li i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #cfd7d3;
}

.quality-card li i.pass {
  background: var(--teal-bright);
  box-shadow: 0 0 0 4px rgba(46, 196, 166, 0.08);
}

.training-pipeline-card {
  min-height: 360px;
}

.pipeline-stage-grid {
  display: grid;
  grid-template-columns: 1fr 1.15fr;
  gap: 14px;
  padding: 20px;
}

.pipeline-stage-grid > section {
  min-width: 0;
  padding: 16px;
  border: 1px solid var(--line);
  border-radius: 9px;
  background: #fafcfb;
}

.stage-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.stage-title > span {
  width: 31px;
  height: 31px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  color: var(--teal);
  border-radius: 50%;
  background: #e5f2ee;
  font: 800 8px/1 monospace;
}

.stage-title strong, .stage-title small {
  display: block;
}

.stage-title strong {
  font-size: 10px;
}

.stage-title small {
  margin-top: 4px;
  color: #8a9591;
  font: 700 7px/1 monospace;
}

.pipeline-stage-grid section > p {
  min-height: 28px;
  margin: 14px 0;
  color: #78847f;
  font-size: 8px;
  line-height: 1.55;
}

.pipeline-stage-grid button {
  width: 100%;
}

.training-config {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
  margin-bottom: 12px;
}

.training-config input {
  height: 32px;
}

.training-lock {
  margin: 0 20px 20px;
  padding: 10px 12px;
  color: #8b6b32;
  border: 1px solid #f0dfbd;
  border-radius: 7px;
  background: #fff9ed;
  font-size: 8px;
  line-height: 1.45;
}

.training-lock span {
  margin-right: 8px;
  color: #a76d0e;
  font: 900 7px/1 monospace;
  letter-spacing: 0.1em;
}

.epoch-status {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  margin-top: 9px;
}

.epoch-status span {
  padding: 7px 5px;
  color: #84908d;
  border-radius: 5px;
  background: #eef2f0;
  font-size: 7px;
  text-align: center;
}

.epoch-status b {
  display: block;
  margin-top: 4px;
  color: var(--ink);
  font: 800 8px/1 monospace;
}

.metrics-card {
  min-height: 260px;
}

.metric-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  padding: 14px 20px;
  background: var(--line);
}

.metric-list div {
  padding: 12px;
  background: white;
}

.metric-list span, .metric-list strong {
  display: block;
}

.metric-list span {
  color: #89948f;
  font-size: 8px;
}

.metric-list strong {
  margin-top: 6px;
  font: 800 15px/1 monospace;
}

.model-location {
  margin: 0 20px 20px;
  padding: 12px;
  color: #bbd0ca;
  border-radius: 7px;
  background: var(--navy);
}

.model-location span, .model-location code, .model-location small {
  display: block;
}

.model-location span {
  color: var(--teal-bright);
  font: 800 7px/1 monospace;
}

.model-location code {
  margin-top: 7px;
  overflow-wrap: anywhere;
  font: 600 8px/1.4 monospace;
}

.model-location small {
  margin-top: 5px;
  color: #6f8780;
  font: 600 7px/1.4 monospace;
}

.ops-footer {
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  color: #8a9591;
  font: 700 7px/1.4 monospace;
  letter-spacing: 0.1em;
}

@media (max-width: 1180px) {
  .ops-shell {
    grid-template-columns: 82px minmax(0, 1fr);
  }
  .rail {
    padding: 26px 14px 20px;
    align-items: center;
  }
  .brand-copy, .rail-nav button > span:not(.nav-icon), .rail-nav button b, .rail-health > div {
    display: none;
  }
  .rail-nav {
    width: 100%;
    margin-top: 48px;
  }
  .rail-nav button {
    grid-template-columns: 1fr;
    justify-items: center;
    padding: 0;
  }
  .rail-health {
    padding: 14px;
  }
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .monitor-layout {
    grid-template-columns: 1fr;
  }
  .agent-layout {
    grid-template-columns: 1fr;
  }
  .monitor-side {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
  }
  .dataset-layout {
    grid-template-columns: 1fr;
  }
  .dataset-side {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 760px) {
  .ops-shell {
    display: block;
  }
  .rail {
    height: 64px;
    position: sticky;
    z-index: 20;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 14px;
  }
  .rail-brand {
    padding: 0;
  }
  .brand-symbol {
    width: 36px;
    height: 36px;
  }
  .brand-copy {
    display: block;
  }
  .rail-nav {
    width: auto;
    display: flex;
    margin: 0;
  }
  .rail-nav button {
    width: 39px;
    min-height: 39px;
  }
  .rail-nav button.active {
    box-shadow: inset 0 -2px var(--teal-bright);
  }
  .rail-health {
    display: none;
  }
  .ops-main {
    padding: 0 14px;
  }
  .ops-header {
    min-height: 86px;
  }
  .ops-header h1 {
    font-size: 19px;
  }
  .environment {
    display: none;
  }
  .refresh {
    width: 34px;
    padding: 0;
    justify-content: center;
    font-size: 0;
  }
  .summary-grid {
    grid-template-columns: 1fr 1fr;
    gap: 9px;
  }
  .summary-card {
    min-height: 100px;
    padding: 14px;
  }
  .summary-card strong {
    font-size: 18px;
  }
  .monitor-side, .dataset-side {
    grid-template-columns: 1fr;
  }
  .agent-info-grid {
    grid-template-columns: 1fr;
  }
  .agent-flow {
    grid-template-columns: 1fr;
  }
  .agent-flow > i {
    transform: rotate(90deg);
    justify-self: center;
  }
  .tool-call-list {
    grid-template-columns: 1fr 1fr;
  }
  .card-head {
    padding: 0 14px;
  }
  .media-viewport {
    min-height: 250px;
    margin: 14px 14px 0;
  }
  .media-viewport video, .drop-zone {
    min-height: 250px;
    height: 250px;
  }
  .file-control {
    margin: 0 14px;
  }
  .analysis-control {
    padding: 14px;
  }
  .source-switch button {
    min-width: 42px;
  }
  .job-row {
    grid-template-columns: 70px 1fr 90px 12px;
  }
  .job-row > span:nth-of-type(2), .job-row > span:nth-of-type(3) {
    display: none;
  }
  .table-head {
    display: none;
  }
  .table-row {
    grid-template-columns: 76px 1fr 40px;
    gap: 9px;
    padding: 10px 0;
  }
  .table-row > span, .table-row > strong, .table-row > time {
    display: none;
  }
  .history-table {
    padding: 0 14px 20px;
  }
  .dataset-steps {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 28px 20px;
  }
  .dataset-steps i {
    width: 1px;
    height: 20px;
    left: 17px;
    top: 34px;
  }
  .dataset-command {
    margin: 0 20px;
  }
  .path-grid {
    grid-template-columns: 1fr;
    margin: 16px 20px 20px;
  }
  .download-guide {
    grid-template-columns: 42px 1fr;
    padding: 16px;
  }
  .download-guide a {
    grid-column: 1/-1;
    text-align: center;
  }
  .registration-form {
    grid-template-columns: 1fr;
    padding: 18px 20px 12px;
  }
  .download-body {
    grid-template-columns: 1fr;
    padding: 16px;
  }
  .approval-steps {
    grid-template-columns: 1fr;
  }
  .catalog-toolbar {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .catalog-toolbar > div {
    flex-basis: 100%;
  }
  .catalog-head, .catalog-row {
    grid-template-columns: 36px 90px minmax(150px, 1fr) minmax(150px, 1fr) 80px;
  }
  .selection-summary {
    grid-template-columns: 1fr;
  }
  .access-diagnostic {
    grid-template-columns: 1fr 1fr;
  }
  .access-diagnostic button, .access-diagnostic p {
    grid-column: 1/-1;
  }
  .manual-upload-grid {
    grid-template-columns: 1fr;
  }
  .download-progress, .capacity-progress {
    margin: 0 16px 16px;
  }
  .task-message {
    margin: 0 20px;
  }
  .pipeline-stage-grid {
    grid-template-columns: 1fr;
    padding: 14px;
  }
  .training-config {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .ops-footer {
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
  }
}
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    scroll-behavior: auto !important;
    transition: none !important;
  }
}`],
})
export class PageMainComponent implements OnInit, OnDestroy {
    public selectedSource: 'file' | 'camera' | 'stream' = 'file';
    public activeSection: 'monitor' | 'agent' | 'history' | 'dataset' = 'monitor';
    public previewUrl = '';
    public fileName = '';
    public fileSize = '';
    public lastChecked = '';
    public statusLoading = false;
    public analysisBusy = false;
    public uploadProgress = 0;
    public analysisMessage = '분석할 영상을 선택해 주세요.';
    public latestResult: AnalysisResult | null = null;
    public analysisJob: AnalysisJob | null = null;
    public agentPrompt = '이 영상에서 위험한 상황이 있는지 확인해줘.';
    public agentBusy = false;
    public agentAnswer = '';
    public agentError = '';
    public agentToolCalls: any[] = [];
    public recentJobs: AnalysisJob[] = [];
    public datasetClassRows: Array<{ label: string; count: number }> = [];
    public datasetSplitRows: Array<{ label: string; count: number }> = [];
    public datasetVideosPath = 'data/aihub/raw';
    public datasetLabelsPath = 'data/aihub/labels';
    public datasetActionBusy = false;
    public pipelineMessage = '';
    public trainingEpochs = 30;
    public trainingBatchSize = 32;
    public trainingLearningRate = 0.001;
    public aihubDatasetKey = 167;
    public aihubOneTimeKey = '';
    public aihubPairs: AIHubPair[] = [];
    public aihubSelectedPairIds: string[] = [];
    public aihubClassFilter = 'all';
    public aihubCatalogLoading = false;
    public aihubCatalogMessage = '파일 목록을 불러오고 있습니다.';
    public aihubCatalogSummary: any = {};
    public aihubDiskFreeBytes = 0;
    public readonly aihubReserveFactor = 2.5;
    public manualSourceArchives: File[] = [];
    public manualLabelArchives: File[] = [];
    public manualInventory: any = {
        sourceFiles: [], labelFiles: [], totalFiles: 0, totalBytes: 0,
        requiredBytes: 0, diskFreeBytes: 0, storageReady: false,
        import: { state: 'idle', message: '압축파일 업로드 대기' }
    };
    public manualUploadBusy = false;
    public manualUploadProgress = 0;
    public manualUploadMessage = 'AIHub 홈페이지에서 직접 받은 압축파일을 선택해 주세요.';

    private selectedFile: File | null = null;
    private readonly maxUploadBytes = 500 * 1024 * 1024;
    private readonly allowedExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'm4v'];
    private statusTimer: any = null;

    public operationsSummary: OperationsSummary = {
        total: 0, completed: 0, waiting: 0, failed: 0, states: {}
    };

    public datasetStatus: DatasetStatus = {
        state: 'empty',
        rawVideos: 0,
        labelFiles: 0,
        manifestRecords: 0,
        invalidRecords: 0,
        processedFiles: 0,
        totalBytes: 0,
        lastPreparedAt: '',
        classCounts: {},
        splitCounts: {},
        paths: {
            raw: 'data/aihub/raw',
            labels: 'data/aihub/labels',
            processed: 'data/aihub/processed'
        },
        registered: false,
        registeredAt: '',
        validation: { state: 'idle', message: '데이터 경로를 등록해 주세요.' },
        sequences: { state: 'idle', message: '실행 대기' },
        training: { state: 'idle', message: '실행 대기' },
        download: { state: 'idle', message: '실행 대기', apiKeyConfigured: false, shellInstalled: false, diskFreeBytes: 0 },
        capacityProcessing: { state: 'idle', message: '일회성 API Key 입력 대기' },
        access: { state: 'idle', message: '승인 상태를 재검증해 주세요.' },
        manualImport: { state: 'idle', message: '압축파일 업로드 대기' },
        validationErrors: []
    };

    public systemStatus: SystemStatus = {
        project: 'Fall Detection AI PBL',
        inference: {
            connected: false,
            label: '연결 확인 중',
            model: '',
            device: 'cpu',
            source: 'none',
            externalConfigured: false,
            local: {
                ready: false,
                state: 'not_loaded',
                backend: 'unconfigured',
                device: 'cpu',
                modelDir: '',
                models: {},
                dependencies: {},
                missing: [],
                missingDependencies: [],
                error: '',
                modelVersion: ''
            }
        },
        pipeline: {
            upload: true,
            maxUploadBytes: this.maxUploadBytes,
            retention: ''
        },
        sources: ['File'],
        toolApi: {
            connected: false, status: 'unavailable', pose_model: false,
            action_model: false, action_model_version: '', source_commit: '0138484'
        },
        agent: { configured: false, provider: 'openai-compatible', model: '', message: 'LLM not configured' }
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.refreshDashboard();
        await this.loadAIHubCatalog();
        await this.loadManualInventory();
        this.statusTimer = setInterval(async () => {
            if (this.hasActivePipeline()) await this.loadOperations();
        }, 5000);
    }

    public ngOnDestroy() {
        if (this.statusTimer) clearInterval(this.statusTimer);
        this.releasePreview();
    }

    public async setSection(section: 'monitor' | 'agent' | 'history' | 'dataset') {
        this.activeSection = section;
        if (section === 'dataset' && !this.aihubPairs.length && !this.aihubCatalogLoading) {
            await this.loadAIHubCatalog(false);
        }
        await this.service.render();
    }

    public async startAgentAnalysis() {
        if (this.agentBusy) return;
        if (!this.selectedFile) {
            this.agentError = '먼저 분석할 영상 파일을 선택해 주세요.';
            await this.service.render();
            return;
        }
        this.agentBusy = true;
        this.agentAnswer = '';
        this.agentError = '';
        this.agentToolCalls = [];
        await this.service.render();
        try {
            const job = await this.uploadSelectedVideo('agent');
            const response = this.normalizeResponse(await wiz.call('agent_chat', {
                message: this.agentPrompt,
                video_id: job.id
            }));
            if (response.code !== 200) {
                throw new Error(this.responseMessage(response, 'Agent 요청을 처리하지 못했습니다.'));
            }
            this.agentAnswer = response.data?.answer || '';
            this.agentToolCalls = response.data?.tool_calls || [];
        } catch (error) {
            this.agentError = error instanceof Error ? error.message : 'Agent 요청을 처리하지 못했습니다.';
        } finally {
            this.agentBusy = false;
            await this.refreshDashboard();
        }
    }

    public async selectSource(source: 'file' | 'camera' | 'stream') {
        this.selectedSource = source;
        await this.service.render();
    }

    public allowDrop(event: DragEvent) {
        event.preventDefault();
    }

    public async onDrop(event: DragEvent) {
        event.preventDefault();
        const file = event.dataTransfer?.files?.[0];
        if (file) await this.useFile(file);
    }

    public async onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (file) await this.useFile(file);
        input.value = '';
    }

    public async clearFile(removeJob = true) {
        const jobId = this.analysisJob?.id;
        if (removeJob && jobId) {
            try {
                await wiz.call('delete_job', { job_id: jobId });
            } catch (_) {
                // 화면 초기화는 계속 진행한다.
            }
        }
        this.releasePreview();
        this.selectedFile = null;
        this.fileName = '';
        this.fileSize = '';
        this.uploadProgress = 0;
        this.analysisMessage = '분석할 영상을 선택해 주세요.';
        this.analysisJob = null;
        this.latestResult = null;
        await this.loadOperations();
        await this.service.render();
    }

    public async deleteJob(job: AnalysisJob) {
        if (this.analysisBusy) return;
        await wiz.call('delete_job', { job_id: job.id });
        if (this.analysisJob?.id === job.id) {
            await this.clearFile(false);
            return;
        }
        await this.loadOperations();
        await this.service.render();
    }

    public async inspectJob(job: AnalysisJob) {
        this.analysisJob = job;
        this.latestResult = job.result;
        this.analysisMessage = this.jobMessage(job);
        this.activeSection = 'monitor';
        await this.service.render();
    }

    public async startAnalysis() {
        if (this.analysisBusy) return;
        if (!this.selectedFile) {
            this.analysisMessage = '먼저 분석할 영상 파일을 선택해 주세요.';
            await this.service.render();
            return;
        }

        this.analysisBusy = true;
        this.uploadProgress = 0;
        this.analysisMessage = this.analysisJob
            ? '등록된 영상으로 분석을 시작합니다.'
            : '영상 업로드 요청을 준비하고 있습니다.';
        this.latestResult = null;
        await this.service.render();

        try {
            const job = await this.uploadSelectedVideo('analysis');
            this.analysisMessage = '영상 등록 완료 · 추론 엔진으로 전달 중입니다.';
            await this.service.render();

            const analyzed = this.normalizeResponse(
                await wiz.call('analyze', { job_id: job.id })
            );

            if (analyzed.data?.job) {
                this.analysisJob = analyzed.data.job;
                this.latestResult = this.analysisJob.result;
            }

            if (analyzed.code === 200 && this.latestResult) {
                this.analysisMessage = '분석을 완료했습니다.';
            } else if (analyzed.code === 409) {
                this.analysisMessage = this.responseMessage(
                    analyzed,
                    '영상은 저장되었으며 추론 모델 연결을 기다리고 있습니다.'
                );
            } else {
                throw new Error(this.responseMessage(analyzed, 'AI 분석에 실패했습니다.'));
            }
        } catch (error) {
            this.analysisMessage = error instanceof Error ? error.message : '분석 요청을 처리하지 못했습니다.';
        } finally {
            this.analysisBusy = false;
            await this.refreshDashboard();
        }
    }

    public async refreshDashboard() {
        this.statusLoading = true;
        await this.service.render();
        try {
            await Promise.all([this.loadSystemStatus(false), this.loadOperations(false)]);
        } finally {
            this.lastChecked = new Date().toLocaleTimeString('ko-KR', {
                hour: '2-digit', minute: '2-digit', second: '2-digit'
            });
            this.statusLoading = false;
            await this.service.render();
        }
    }

    public async loadSystemStatus(render = true) {
        const response: any = await wiz.call('status');
        if (response.code === 200 && response.data) {
            this.systemStatus = response.data;
        }
        if (render) await this.service.render();
    }

    public async loadOperations(render = true) {
        const response: any = await wiz.call('operations', { limit: 30 });
        if (response.code === 200 && response.data) {
            this.recentJobs = response.data.jobs || [];
            this.operationsSummary = response.data.summary || this.operationsSummary;
            this.datasetStatus = response.data.dataset || this.datasetStatus;
            if (this.datasetStatus.registered) {
                this.datasetVideosPath = this.datasetStatus.paths.raw;
                this.datasetLabelsPath = this.datasetStatus.paths.labels;
            }
            this.datasetClassRows = this.toRows(this.datasetStatus.classCounts);
            this.datasetSplitRows = this.toRows(this.datasetStatus.splitCounts);
        }
        if (render) await this.service.render();
    }

    public riskLabel(level: string) {
        if (level === 'danger') return '낙상';
        if (level === 'warning') return '주의';
        return '정상';
    }

    public stateLabel(state: string) {
        const labels: { [key: string]: string } = {
            uploaded: '업로드됨',
            analyzing: '분석 중',
            completed: '완료',
            waiting_for_model: '모델 대기',
            failed: '실패'
        };
        return labels[state] || state;
    }

    public datasetStateLabel() {
        if (this.datasetStatus.state === 'ready') return '학습 준비 완료';
        if (this.datasetStatus.state === 'needs_processing') return '전처리 필요';
        return '데이터 대기';
    }

    public classLabel(value: string) {
        if (value === 'normal') return '정상';
        if (value === 'warning') return '주의';
        if (value === 'fall') return '낙상';
        return value;
    }

    public pipelineStateLabel(value: string) {
        const labels: { [key: string]: string } = {
            idle: '대기', running: '진행 중', restarting: '자동 재시작',
            completed: '완료', space_blocked: '공간 부족 종료', failed: '실패'
        };
        return labels[value] || value;
    }

    public canExtract() {
        return this.datasetStatus.state === 'ready'
            && this.datasetStatus.sequences?.state !== 'running';
    }

    public hasActivePipeline() {
        return ['running', 'preflight'].includes(this.datasetStatus.download?.state)
            || ['running', 'restarting', 'preflight'].includes(this.datasetStatus.capacityProcessing?.state)
            || this.datasetStatus.validation?.state === 'running'
            || this.datasetStatus.manualImport?.state === 'running'
            || this.datasetStatus.sequences?.state === 'running'
            || this.datasetStatus.training?.state === 'running';
    }

    public get filteredAIHubPairs() {
        const pairs = this.aihubClassFilter === 'all'
            ? this.aihubPairs
            : this.aihubPairs.filter(pair => pair.className === this.aihubClassFilter);
        return [...pairs].sort((left, right) => left.totalBytes - right.totalBytes);
    }

    public get selectedAIHubPairs() {
        const selected = new Set(this.aihubSelectedPairIds);
        return this.aihubPairs.filter(pair => selected.has(pair.id));
    }

    public get selectedAIHubBytes() {
        return this.selectedAIHubPairs.reduce((total, pair) => total + pair.totalBytes, 0);
    }

    public get selectedAIHubRequiredBytes() {
        return Math.ceil(this.selectedAIHubBytes * this.aihubReserveFactor);
    }

    public get aihubStorageReady() {
        return this.selectedAIHubBytes > 0 && this.aihubDiskFreeBytes >= this.selectedAIHubRequiredBytes;
    }

    public isAIHubPairSelected(pairId: string) {
        return this.aihubSelectedPairIds.includes(pairId);
    }

    public async toggleAIHubPair(pairId: string) {
        this.aihubSelectedPairIds = this.isAIHubPairSelected(pairId)
            ? this.aihubSelectedPairIds.filter(value => value !== pairId)
            : [...this.aihubSelectedPairIds, pairId];
        await this.service.render();
    }

    public async selectSmallBalancedSet() {
        const selected: string[] = [];
        for (const className of ['normal', 'warning', 'fall']) {
            const pair = this.aihubPairs
                .filter(item => item.className === className)
                .sort((left, right) => left.totalBytes - right.totalBytes)[0];
            if (pair) selected.push(pair.id);
        }
        this.aihubSelectedPairIds = selected;
        await this.service.render();
    }

    public async clearAIHubSelection() {
        this.aihubSelectedPairIds = [];
        await this.service.render();
    }

    public async loadAIHubCatalog(render = true) {
        if (this.aihubCatalogLoading) return;
        this.aihubCatalogLoading = true;
        this.aihubCatalogMessage = 'dataset 파일 목록을 조회하고 있습니다.';
        if (render) await this.service.render();
        try {
            const response = this.normalizeResponse(await wiz.call('aihub_catalog', {
                dataset_key: this.aihubDatasetKey
            }));
            if (response.code !== 200) {
                throw new Error(this.responseMessage(response, 'AIHub 파일 목록 조회에 실패했습니다.'));
            }
            this.aihubPairs = response.data?.pairs || [];
            this.aihubCatalogSummary = response.data?.summary || {};
            this.aihubDiskFreeBytes = response.data?.diskFreeBytes || 0;
            const validIds = new Set(this.aihubPairs.map(pair => pair.id));
            this.aihubSelectedPairIds = this.aihubSelectedPairIds.filter(value => validIds.has(value));
            this.aihubCatalogMessage = `${this.aihubPairs.length}개 원천 영상-라벨 쌍을 조회했습니다.`;
        } catch (error) {
            this.aihubPairs = [];
            this.aihubCatalogMessage = error instanceof Error ? error.message : '파일 목록 조회에 실패했습니다.';
        } finally {
            this.aihubCatalogLoading = false;
            if (render) await this.service.render();
        }
    }

    public async startAIHubDownload() {
        if (this.datasetActionBusy || !this.aihubDatasetKey || !this.aihubStorageReady || !this.aihubSelectedPairIds.length) return;
        this.datasetActionBusy = true;
        this.pipelineMessage = 'AIHub 다운로드 용량과 승인 상태를 확인합니다.';
        await this.service.render();
        try {
            const response = this.normalizeResponse(await wiz.call('start_aihub_download', {
                dataset_key: this.aihubDatasetKey,
                pair_ids: this.aihubSelectedPairIds.join(',')
            }));
            if (response.code !== 202) {
                throw new Error(this.responseMessage(response, 'AIHub 다운로드를 시작하지 못했습니다.'));
            }
            this.pipelineMessage = '서버 다운로드 작업을 시작했습니다. 중단 시 동일 key로 다시 실행하면 재개합니다.';
        } catch (error) {
            this.pipelineMessage = error instanceof Error ? error.message : '다운로드 시작에 실패했습니다.';
        } finally {
            this.datasetActionBusy = false;
            await this.loadOperations(false);
            await this.service.render();
        }
    }

    public async startAIHubCapacityProcessing() {
        if (this.datasetActionBusy || this.datasetStatus.capacityProcessing?.state === 'running') return;
        let oneTimeKey = this.aihubOneTimeKey.trim();
        if (!oneTimeKey) return;

        this.aihubOneTimeKey = '';
        this.datasetActionBusy = true;
        this.pipelineMessage = '일회성 API Key 인증과 dataset 167 승인을 확인합니다.';
        await this.service.render();
        try {
            const response = this.normalizeResponse(await wiz.call('start_aihub_capacity_processing', {
                api_key: oneTimeKey
            }));
            oneTimeKey = '';
            if (response.code !== 202) {
                throw new Error(this.responseMessage(response, '연속 처리 작업을 시작하지 못했습니다.'));
            }
            this.datasetStatus.capacityProcessing = response.data?.capacityProcessing || this.datasetStatus.capacityProcessing;
            this.pipelineMessage = '인증 확인 완료: Supervisor가 전체 미처리 데이터를 감시하며 자동 재시작합니다.';
        } catch (error) {
            this.pipelineMessage = error instanceof Error ? error.message : '일회성 인증 또는 연속 처리 시작에 실패했습니다.';
        } finally {
            oneTimeKey = '';
            this.aihubOneTimeKey = '';
            this.datasetActionBusy = false;
            await this.loadOperations(false);
            await this.service.render();
        }
    }

    public async recheckAIHubApproval() {
        if (this.datasetActionBusy) return;
        const targets = [
            ['fall', 'H11H22H32.zip'],
            ['warning', 'W11W23.zip'],
            ['normal', 'M_I_007.zip']
        ];
        this.aihubSelectedPairIds = targets
            .map(([className, name]) => this.aihubPairs.find(pair => pair.className === className && pair.name === name)?.id)
            .filter((value): value is string => Boolean(value));
        this.datasetActionBusy = true;
        this.pipelineMessage = 'API Key 인증과 dataset 167 승인 상태를 분리 진단합니다.';
        await this.service.render();
        let approved = false;
        try {
            const response = this.normalizeResponse(await wiz.call('diagnose_aihub_access'));
            if (response.code !== 200 || !response.data?.access) {
                throw new Error(this.responseMessage(response, 'AIHub 승인 상태를 확인하지 못했습니다.'));
            }
            this.datasetStatus.access = response.data.access;
            approved = response.data.access.state === 'approved';
            this.pipelineMessage = response.data.access.message;
        } catch (error) {
            this.pipelineMessage = error instanceof Error ? error.message : '승인 재검증에 실패했습니다.';
        } finally {
            this.datasetActionBusy = false;
            await this.loadOperations(false);
            await this.service.render();
        }
        if (approved) await this.startAIHubDownload();
    }

    public async onManualArchiveSelected(event: Event, kind: 'source' | 'label') {
        const input = event.target as HTMLInputElement;
        const files = Array.from(input.files || []);
        if (kind === 'source') this.manualSourceArchives = files;
        else this.manualLabelArchives = files;
        await this.service.render();
    }

    public async uploadManualArchives(kind: 'source' | 'label') {
        const files = kind === 'source' ? this.manualSourceArchives : this.manualLabelArchives;
        if (!files.length || this.manualUploadBusy) return;
        this.manualUploadBusy = true;
        this.manualUploadProgress = 0;
        this.manualUploadMessage = `${kind === 'source' ? '원천 영상' : '라벨'} 압축파일을 업로드하고 있습니다.`;
        await this.service.render();
        try {
            for (let index = 0; index < files.length; index += 1) {
                const formData = new FormData();
                formData.append('file', files[index], files[index].name);
                const endpoint = kind === 'source' ? 'upload_aihub_source_archive' : 'upload_aihub_label_archive';
                const uploaded = this.normalizeResponse(await this.service.file.upload(
                    wiz.url(endpoint),
                    formData,
                    async (percent) => {
                        this.manualUploadProgress = Math.round(((index + percent / 100) / files.length) * 100);
                        await this.service.render();
                    }
                ));
                if (uploaded.code !== 201) {
                    throw new Error(this.responseMessage(uploaded, `${files[index].name} 업로드에 실패했습니다.`));
                }
                this.manualInventory = uploaded.data?.inventory || this.manualInventory;
            }
            this.manualUploadProgress = 100;
            this.manualUploadMessage = `${files.length}개 압축파일 업로드를 완료했습니다.`;
            if (kind === 'source') this.manualSourceArchives = [];
            else this.manualLabelArchives = [];
        } catch (error) {
            this.manualUploadMessage = error instanceof Error ? error.message : '압축파일 업로드에 실패했습니다.';
        } finally {
            this.manualUploadBusy = false;
            await this.loadManualInventory(false);
            await this.service.render();
        }
    }

    public async loadManualInventory(render = true) {
        try {
            const response = this.normalizeResponse(await wiz.call('manual_aihub_inventory'));
            if (response.code === 200 && response.data?.inventory) {
                this.manualInventory = response.data.inventory;
            }
        } catch (_) {
            this.manualUploadMessage = '서버 반입 파일 목록을 확인하지 못했습니다.';
        }
        if (render) await this.service.render();
    }

    public async startManualImport() {
        if (this.datasetActionBusy || this.manualUploadBusy || !this.manualInventory.storageReady) return;
        this.datasetActionBusy = true;
        this.manualUploadMessage = '안전 압축해제·영상 라벨 검증·포즈 추출을 시작합니다.';
        await this.service.render();
        try {
            const response = this.normalizeResponse(await wiz.call('start_manual_aihub_import'));
            if (response.code !== 202) {
                throw new Error(this.responseMessage(response, '수동 반입 작업을 시작하지 못했습니다.'));
            }
            this.manualUploadMessage = '수동 반입 파이프라인을 시작했습니다.';
        } catch (error) {
            this.manualUploadMessage = error instanceof Error ? error.message : '수동 반입 시작에 실패했습니다.';
        } finally {
            this.datasetActionBusy = false;
            await this.loadOperations(false);
            await this.loadManualInventory(false);
            await this.service.render();
        }
    }

    public canTrain() {
        return this.datasetStatus.state === 'ready'
            && this.datasetStatus.sequences?.state === 'completed'
            && this.datasetStatus.training?.state !== 'running';
    }

    public async registerDataset() {
        if (this.datasetActionBusy) return;
        this.datasetActionBusy = true;
        this.pipelineMessage = '데이터 경로를 등록하고 검증을 시작합니다.';
        await this.service.render();
        try {
            const response = this.normalizeResponse(await wiz.call('register_dataset', {
                videos_path: this.datasetVideosPath,
                labels_path: this.datasetLabelsPath
            }));
            if (response.code !== 202) {
                throw new Error(this.responseMessage(response, '데이터 경로를 등록하지 못했습니다.'));
            }
            this.pipelineMessage = '등록 완료 · 자동 검증과 manifest 생성이 진행 중입니다.';
        } catch (error) {
            this.pipelineMessage = error instanceof Error ? error.message : '데이터 등록에 실패했습니다.';
        } finally {
            this.datasetActionBusy = false;
            await this.loadOperations(false);
            await this.service.render();
        }
    }

    public async startSequenceExtraction() {
        if (!this.canExtract() || this.datasetActionBusy) return;
        this.datasetActionBusy = true;
        this.pipelineMessage = '사람·포즈 키포인트 시퀀스 추출을 시작합니다.';
        await this.service.render();
        try {
            const response = this.normalizeResponse(await wiz.call('start_sequence_extraction'));
            if (response.code !== 202) {
                throw new Error(this.responseMessage(response, '시퀀스 추출을 시작하지 못했습니다.'));
            }
            this.pipelineMessage = '포즈 시퀀스 추출 작업을 시작했습니다.';
        } catch (error) {
            this.pipelineMessage = error instanceof Error ? error.message : '시퀀스 추출 시작에 실패했습니다.';
        } finally {
            this.datasetActionBusy = false;
            await this.loadOperations(false);
            await this.service.render();
        }
    }

    public async startModelTraining() {
        if (!this.canTrain() || this.datasetActionBusy) return;
        this.datasetActionBusy = true;
        this.pipelineMessage = '행동 분류 모델 학습을 시작합니다.';
        await this.service.render();
        try {
            const response = this.normalizeResponse(await wiz.call('start_training', {
                epochs: this.trainingEpochs,
                batch_size: this.trainingBatchSize,
                learning_rate: this.trainingLearningRate
            }));
            if (response.code !== 202) {
                throw new Error(this.responseMessage(response, '모델 학습을 시작하지 못했습니다.'));
            }
            this.pipelineMessage = '학습 작업을 시작했습니다. 새로고침으로 진행 상태를 확인하세요.';
        } catch (error) {
            this.pipelineMessage = error instanceof Error ? error.message : '학습 시작에 실패했습니다.';
        } finally {
            this.datasetActionBusy = false;
            await this.loadOperations(false);
            await this.service.render();
        }
    }

    public formatTimestamp(value: string) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return date.toLocaleString('ko-KR', {
            month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
        });
    }

    public formatOccurrence(value: number | null) {
        if (value === null || value === undefined) return '-';
        const minutes = Math.floor(value / 60);
        const seconds = value - (minutes * 60);
        return `${minutes.toString().padStart(2, '0')}:${seconds.toFixed(3).padStart(6, '0')}`;
    }

    public formatBytes(value: number) {
        if (!value) return '0 B';
        if (value < 1024) return `${value} B`;
        if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
        if (value < 1024 * 1024 * 1024) return `${(value / (1024 * 1024)).toFixed(1)} MB`;
        return `${(value / (1024 * 1024 * 1024)).toFixed(1)} GB`;
    }

    public jobMessage(job: AnalysisJob) {
        if (job.result) return job.result.summary;
        return job.error || `${this.stateLabel(job.state)} 상태입니다.`;
    }

    private async useFile(file: File) {
        const extension = file.name.includes('.') ? file.name.split('.').pop()!.toLowerCase() : '';

        // 브라우저/OS가 MKV·MOV 등을 application/octet-stream으로 보고해도
        // 허용 확장자는 선택하고, 실제 형식은 서버의 파일 시그니처 검사로 확정한다.
        if (!this.allowedExtensions.includes(extension)) {
            this.releasePreview();
            this.selectedFile = null;
            this.fileName = '';
            this.fileSize = '';
            this.analysisJob = null;
            this.latestResult = null;
            this.analysisMessage = 'MP4, MOV, AVI, MKV, WEBM, M4V 영상만 선택할 수 있습니다.';
            await this.service.render();
            return;
        }
        if (file.size <= 0 || file.size > this.maxUploadBytes) {
            this.releasePreview();
            this.selectedFile = null;
            this.fileName = '';
            this.fileSize = '';
            this.analysisJob = null;
            this.latestResult = null;
            this.analysisMessage = '영상 파일은 500MB 이하만 선택할 수 있습니다.';
            await this.service.render();
            return;
        }

        this.releasePreview();
        this.selectedFile = file;
        this.fileName = file.name;
        this.fileSize = this.formatBytes(file.size);
        this.previewUrl = URL.createObjectURL(file);
        this.uploadProgress = 0;
        this.analysisMessage = '영상이 준비되었습니다. 분석을 시작해 주세요.';
        this.analysisJob = null;
        this.latestResult = null;
        await this.service.render();
    }

    private async uploadSelectedVideo(purpose: 'analysis' | 'agent'): Promise<AnalysisJob> {
        if (this.analysisJob?.id) return this.analysisJob;
        if (!this.selectedFile) {
            throw new Error('업로드할 영상 파일이 없습니다. 영상을 다시 선택해 주세요.');
        }

        const endpoint = wiz.url('upload');
        const formData = new FormData();
        formData.append('file', this.selectedFile, this.selectedFile.name);
        this.analysisMessage = purpose === 'agent'
            ? 'Agent 분석용 영상을 서버에 등록하고 있습니다.'
            : '영상을 서버에 업로드하고 있습니다.';
        await this.service.render();

        const rawResponse = await this.service.file.upload(
            endpoint,
            formData,
            async (percent) => {
                this.uploadProgress = Math.round(percent);
                await this.service.render();
            }
        );
        const uploaded = this.normalizeResponse(rawResponse);
        if (Number(uploaded.code) !== 201 || !uploaded.data?.job?.id) {
            throw new Error(this.responseMessage(
                rawResponse,
                purpose === 'agent'
                    ? 'Agent용 영상 업로드에 실패했습니다.'
                    : '영상 업로드에 실패했습니다.'
            ));
        }

        const registeredJob = uploaded.data.job as AnalysisJob;
        this.analysisJob = registeredJob;
        this.uploadProgress = 100;
        await this.service.render();
        return registeredJob;
    }

    private toRows(source: { [key: string]: number }) {
        return Object.keys(source || {})
            .map((label) => ({ label, count: Number(source[label]) || 0 }))
            .sort((a, b) => b.count - a.count);
    }

    private normalizeResponse(response: any) {
        return response?.responseJSON || response || {};
    }

    private responseMessage(response: any, fallback: string) {
        const payload = this.normalizeResponse(response);
        const message = payload?.data?.message || payload?.detail || payload?.message;
        if (message) return String(message);

        const status = Number(response?.status || 0);
        const statusText = String(response?.statusText || '').trim();
        if (status >= 400) {
            return `${fallback} (HTTP ${status}${statusText ? ` ${statusText}` : ''})`;
        }
        return fallback;
    }

    private releasePreview() {
        if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = '';
    }
}

export default PageMainComponent;